import React, { useState } from "react";

/// React router dom
import { Link } from "react-router-dom";

/// images
import blueStar_logo from "../../images/blueStar_logo.png";

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  return (
    <div className="nav-header" style={{ backgroundColor: "#40189D" }}>
      <Link to="/" className="brand-logo">
        <img
          src={blueStar_logo}
          alt=""
          style={{ width: "170px", height: "60px" }}
        />
      </Link>

      <div className="nav-control" onClick={() => setToggle(!toggle)}>
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
